import React from 'react';
import './NewIntro.css'
import IntroHeader from '../UI/Intro/IntroHeader';
import IntroHero from '../UI/Intro/IntroHero';
import IntroMain from '../UI/Intro/IntroMain';
import IntroFooter from '../UI/Intro/IntroFooter';


const NewIntro = () => {

    return (
        <>
        <div className='outer-header'>
            <IntroHeader />
        </div>
        <div className='outer-main'>
            {/* header */}
            
            <div className='resp-hero'>
                {/* Hero */}
                <IntroHero />
            </div>

            {/* Intro main */}
            <IntroMain />
            {/* Intro footer */}
           
        </div>
        <div className='outer-footer'>
            <IntroFooter />
        </div>
        </>
    )
}
export default NewIntro;